export default __webpack_public_path__ + "static/media/add.dd0362d5.svg";